module.exports = __webpack_public_path__ + "Web.svg?9e31d62b607eeaf1ed816bf81e8b9a62";